import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 159F7B23-A336-4F8C-A3BB-D8AB143D6661
 * name sign-caution
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sign-caution.svg
 * tags
 * - Transportation + Road 
 */
export const SignCautionIcon = createSvgIcon(<><path d="M2,3H22V13H18V21H16V13H8V21H6V13H2V3M18.97,11L20,9.97V7.15L16.15,11H18.97M13.32,11L19.32,5H16.5L10.5,11H13.32M7.66,11L13.66,5H10.83L4.83,11H7.66M5.18,5L4,6.18V9L8,5H5.18Z" /></>, 'SignCautionIcon');
export default SignCautionIcon